<template>
    <div class="app">
        <!-- 头部区域 -->
        <header class="header">
            <div class="top-bar">
                <div class="logo">炜品城</div>
                <div class="location" @click="toLocation">
                    定位地址 <span>></span>
                </div>
            </div>
            <div class="search-box" @click="toSearch">
                <div class="search-box-inner">
                    <span class="search-icon">🔍</span>
                    <span class="division"></span>
                    <input type="text" style="border: none;" placeholder="品质肉禽" v-model="searchValue" />
                </div>
                <div class="search-btn">搜索</div>
            </div>

            <!-- 会员大礼卡片 -->
            <div class="member-card" @click="joinMember">
                <img src="/static/home/Rectangle 1353.png" alt="" style="height: 100%;width: 100%;">
            </div>
        </header>

        <!-- 分类导航 (品质肉禽等) -->
        <div class="categories">
            <div class="cat-item" v-for="cat in categoryList" :key="cat.name" @click="toCategory(cat)">
                <img :src="'/static/home/' + cat.url" alt="" class="cat-icon">
                <span>{{ cat.name }}</span>
            </div>
        </div>

        <!-- 广告位 -->
        <div class="advertisement">
            <img src="/static/home/Frame 287.png" alt="" style="width: 180px;height: 113px;">
            <img src="/static/home/Frame 288.png" alt="" style="width: 72px;height: 113px;">
            <img src="/static/home/Frame 289.png" alt="" style="width: 72px;height: 113px;">
        </div>

        <!-- 猜你喜欢 (带选项卡) -->
        <div class="tabs">
            <div class="tab-item">
                <div class="tab" :class="{ active: activeTab === 'recommend' }" @click="activeTab = 'recommend'">
                    猜你喜欢
                </div>
                <div v-if="activeTab === 'recommend'" class="tab-bar"></div>
            </div>
            <div class="tab-item">
                <div class="tab" :class="{ active: activeTab === 'hot' }" @click="activeTab = 'hot'">
                    热销爆款
                </div>
                <div v-if="activeTab === 'hot'" class="tab-bar"></div>
            </div>
            <div class="tab-item">
                <div class="tab" :class="{ active: activeTab === 'new' }" @click="activeTab = 'new'">
                    新品上市
                </div>
                <div v-if="activeTab === 'new'" class="tab-bar"></div>
            </div>
        </div>

        <!-- 猜你喜欢商品区域：两列瀑布布局 -->
        <div class="section">
            <div class="waterfall">
                <!-- 左侧列 -->
                <div class="waterfall-col left-col">
                    <!-- 固定大图 -->
                    <div class="feature-card">
                        <img src="/static/home/Rectangle 1382.png" alt="" class="feature-img">
                    </div>
                    <!-- 左侧商品列表 -->
                    <div class="product-card" v-for="item in leftItems" :key="'left-' + item.id"
                        @click="$router.push({ path: item.path })">
                        <img :src="item.img" alt="" class="product-thumb">
                        <div class="product-info">
                            <div class="product-title">{{ item.title }}</div>
                            <div class="product-desc">{{ item.desc }}</div>
                            <!-- <div style="display: flex;">
                                <div class="price-tag">新人首单价</div>
                                <div class="price-tag">近30天最低价</div>
                            </div> -->
                            <div class="price-row">
                                <div
                                    :style="item.points && item.price ? 'display: flex;flex-wrap: nowrap;align-items: flex-end;' : ''">
                                    <span class="current-price" v-if="item.points">{{ item.points }}<span
                                            style="font-size: 10px;">积分</span> </span>
                                    <span style="font-size: 10px; color:#ff3b2f; margin: 0 4px;line-height: 1.5;"
                                        v-if="item.price && item.points">+</span>
                                    <span class="current-price" v-if="item.price"><span
                                            style="font-size: 10px;">¥</span>{{ item.price
                                            }}</span>
                                    <span class="old-price" v-if="item.oldPrice">¥{{ item.oldPrice }}</span>
                                </div>
                                <div class="add">+</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧列 -->
                <div class="waterfall-col right-col">
                    <div class="product-card" v-for="item in rightItems" :key="'right-' + item.id"
                        @click="$router.push({ path: item.path })">
                        <img :src="item.img" alt="" class="product-thumb">
                        <div class="product-info">
                            <div class="product-title">{{ item.title }}</div>
                            <div class="product-desc">{{ item.desc }}</div>
                            <!-- <div style="display: flex;">
                                <div class="price-tag">新人首单价</div>
                                <div class="price-tag">近30天最低价</div>
                            </div> -->
                            <div class="price-row">
                                <div
                                    :style="item.points && item.price ? 'display: flex;flex-wrap: nowrap;align-items: flex-end;' : ''">
                                    <span class="current-price" v-if="item.points">{{ item.points }}<span
                                            style="font-size: 10px;">积分</span></span>
                                    <span style="font-size: 10px; color:#ff3b2f; margin: 0 5px; line-height: 1.5;"
                                        v-if="item.price && item.points">+</span>
                                    <span class="current-price" v-if="item.price"><span
                                            style="font-size: 10px;">¥</span>{{ item.price
                                            }}</span>
                                    <span class="old-price" v-if="item.oldPrice">¥{{ item.oldPrice }}</span>
                                </div>
                                <div class="add">+</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomePage',
    data() {
        return {
            activeTab: 'recommend',
            searchValue: '',
            categoryList: [
                { name: '超值抢购', url: 'Frame 286.png' },
                { name: '甄选精品', url: 'Frame 290.png' },
                { name: '家居用品', url: 'Frame 291.png' },
                { name: '生活日化', url: 'Frame 292.png' },
                { name: '数码电器', url: 'Frame 293.png' },
                { name: '个人养护', url: 'Frame 294.png' },
                { name: '健康养生', url: 'Frame 295.png' },
                { name: '酒水饮料', url: 'Frame 296.png' },
                { name: '粮油食品', url: 'Rectangle 1363.png' },
                { name: '成人用品', url: 'Frame 297.png' },
            ],
            recommendList: [
                { id: 17, title: '荣事达电煮锅一体锅多功能电炒锅家用火锅电锅蒸煮炒煎电热火锅', desc: '加热块 | 更方便快捷', price: '69.90', oldPrice: '109', img: '/static/home/Rectangle 1384.png', path: '/detail' },
                { id: 18, title: '小熊蒸蛋器2025新款自动断电煮蛋器家用小型蒸锅一体玉米鸡蛋神器', desc: '可蒸煮 | 一键易操作', points: '550', price: '38.8', img: '/static/home/zhengdan.png', path: '/detail' },
                { id: 19, title: '小熊养生壶炖煮一体煮茶壶2026新款保温家用烧水壶官方旗舰店正品', desc: '0胶水更安心 | 入口安全有保障', points: '3793', oldPrice: '79.90', img: '/static/home/zhucha.png', path: '/detail' },
                { id: 20, title: '法国红酒整箱干红葡萄酒赤霞珠红酒14度官方正品旗舰店礼盒装送礼', desc: '果香浓郁 | 口感顺滑', points: '1620', oldPrice: '18.4', img: '/static/home/hongjiu.png', path: '/detail' },
                { id: 21, title: 'SHAREDNOTES生椰莫斯卡托甜白葡萄酒北欧风浮雕瓶椰子果酒6度微醺', desc: '椰子果香 | 清爽不腻', points: '550', price: '9.9', img: '/static/home/tianjiu.png', path: '/detail' },
            ],
            hotList: [
                { id: 101, title: '智能空气炸锅', desc: '无油烹饪 销量冠军', price: '189.00', oldPrice: '299.00', img: '/static/home/Rectangle 1384.png' },
                { id: 102, title: '山茶花洗护套装', desc: '月销2w+ 爆款返场', price: '69.00', oldPrice: '129.00', img: '/static/home/Rectangle 1384.png' },
                { id: 103, title: '有机五常大米', desc: '热销榜第一 10斤装', price: '55.90', oldPrice: '89.90', img: '/static/home/Rectangle 1384.png' },
                { id: 104, title: '脆甜爆浆小番茄', desc: '复购率No.1 新鲜直送', price: '9.90', oldPrice: '19.90', img: '/static/home/Rectangle 1384.png' },
                { id: 105, title: '精品牛肉礼盒', desc: '澳洲进口 原切牛排', price: '118.00', oldPrice: '198.00', img: '/static/home/Rectangle 1384.png' },
                { id: 106, title: '荣事达电饭煲', desc: '蒸煮煎炒焖炖涮', price: '149.00', oldPrice: '299.00', img: '/static/home/Rectangle 1384.png' }
            ],
            newList: [
                { id: 201, title: '春季限定樱花杯', desc: '新品首发 限时尝鲜', price: '29.90', oldPrice: '49.90', img: '/static/home/Rectangle 1384.png' },
                { id: 202, title: '智能扫拖机器人', desc: '激光导航 新品爆款', price: '1299.00', oldPrice: '1999.00', img: '/static/home/Rectangle 1384.png' },
                { id: 203, title: '低脂轻食鸡胸肉', desc: '10种口味 新品上市', price: '49.90', oldPrice: '79.90', img: '/static/home/Rectangle 1384.png' },
                { id: 204, title: '国潮文创茶具套装', desc: '设计款 限量发售', price: '89.00', oldPrice: '159.00', img: '/static/home/Rectangle 1384.png' },
                { id: 205, title: '便携式榨汁杯', desc: '无线充电 新品尝鲜', price: '59.00', oldPrice: '99.00', img: '/static/home/Rectangle 1384.png' },
                { id: 206, title: '空气循环扇', desc: '静音节能 夏季新品', price: '199.00', oldPrice: '299.00', img: '/static/home/Rectangle 1384.png' }
            ]
        };
    },
    computed: {
        currentList() {
            if (this.activeTab === 'recommend') return this.recommendList;
            if (this.activeTab === 'hot') return this.hotList;
            return this.newList;
        },
        // 左侧列商品：索引为偶数（0,2,4...）
        leftItems() {
            return this.currentList.filter((_, index) => index % 2 === 1);
        },
        // 右侧列商品：索引为奇数（1,3,5...）
        rightItems() {
            return this.currentList.filter((_, index) => index % 2 === 0);
        }
    },
    methods: {
        toLocation() { console.log('定位地址点击'); },
        toSearch() { console.log('搜索点击'); },
        joinMember() { console.log('立即参与会员'); },

        toCategory(category) {
            console.log(`点击分类: ${category.name}`);
            this.$router.push({
                path: '/categories',
                query: {
                    category: category.name
                }
            });
        }
    }
};
</script>

<style scoped>
/* 全局重置 */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
}

body {
    background-color: #f5f5f5;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.app {
    max-width: 450px;
    margin: 0 auto;
    background-color: #f8f8f8;
    padding-bottom: 100px;
}

/* 头部 */
.header {
    background-image: linear-gradient(to bottom, #bcf7c0, rgba(188, 247, 192, 0));
    padding: 12px 16px 8px;
}

.top-bar {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.logo {
    font-weight: bold;
    font-size: 17px;
    color: #000000;
}

.location {
    font-weight: 400;
    font-size: 11px;
    color: #000000;
    margin-left: 30px;
    cursor: pointer;
}

.search-box {
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 6px;
    cursor: pointer;
}

.search-box-inner {
    display: flex;
    align-items: center;
}

.search-icon {
    font-size: 16px;
}

.division {
    display: inline-block;
    width: 0;
    height: 20px;
    border: 1px solid #8B8B8B;
    margin: 0 8px;
}

.search-btn {
    width: 46px;
    height: 20px;
    background: #06CF33;
    border-radius: 10px;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
}

/* 会员卡片 */
.member-card {
    display: flex;
    justify-content: center;
    margin: 8px 20px;
}

/* 分类导航 - 一行5个 */
.categories {
    display: flex;
    flex-wrap: wrap;
    padding: 14px 12px 0;
    background: #fff;
    border-radius: 6px;
    margin: 12px 20px;
}

.cat-item {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    color: #333;
    margin-bottom: 14px;
}

.cat-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 5px;
}

/* 广告位 */
.advertisement {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 0 20px;
}

/* 猜你喜欢区域容器 */
.section {
    margin: 12px 16px;
    border-radius: 20px;
    padding: 14px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

/* 选项卡样式 */
.tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin: 14px 16px 0 16px;
    padding-bottom: 6px;
}

.tab-item {
    position: relative;
}

.tab {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
}

.tab.active {
    font-weight: 700;
    font-size: 18px;
    color: #000;
}

.tab-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: #FF6D6D;
    border-radius: 3px;
    opacity: 0.8;
}

/* 瀑布流两列布局 */
.waterfall {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    /* 顶部对齐，产生错落 */
}

.waterfall-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* 固定大图卡片 */
.feature-card {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
}

.feature-img {
    width: 100%;
    height: auto;
    display: block;
}

/* 商品卡片 */
.product-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: auto;
    /* 高度由内容决定 */
}

.product-thumb {
    width: 100%;
    height: auto;
    display: block;
    background: #e9e9e9;
}

.product-info {
    padding: 8px 6px;
}

.product-title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 1.4;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-desc {
    margin: 6px 0;
    font-weight: 300;
    font-size: 10px;
    color: #666;
    text-align: left;
}

.price-tag {
    height: 10px;
    border-radius: 2px;
    border: 1px solid #FF0000;
    text-align: center;
    color: #FF0000;
    font-size: 5px;
    margin-right: 6px;
    padding: 0 3px;
}

.price-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 6px;
    margin: 8px 0 4px;
    padding: 0 10px 0 5px;
}

.add {
    width: 17px;
    height: 17px;
    background: #06CF33;
    border-radius: 50%;
    line-height: 17px;
    text-align: center;
    color: #fff;
    font-size: 18px;
}

.current-price {
    font-size: 18px;
    font-weight: 800;
    color: #ff3b2f;
}

.old-price {
    font-size: 11px;
    color: #aaa;
    text-decoration: line-through;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue